import React, { useEffect, useState } from "react";
import DataComponent from "../../../components/DataComponent";
import Icon from "../../../components/Icon";
import LockIcon from "../../../assets/images/icon/lock.svg";
import ShieldIcon from "../../../assets/images/icon/shield.svg";
import { CardUnit } from "../../../components/ContentLayout";
import { CardBody, CardHeader, CardTitle } from "reactstrap";
import { isEmpty } from "lodash";
import FinancesCert from "../../../components/FinancesCert/idnex";
import {
  getFinancesAccounts,
  getFinancesType,
  modifyFinancesAccounts,
  postFinancesAuth,
} from "../../../apis/finances/auth";
import { viewLoading } from "../../../utils/loading";
import { FINANCE_SCRAPING_STATE } from "../../../constants/SCRAPING_DATA";
import Badge from "../../../components/Badge";

export const findCertName = (cert) => {
  const certVal = String(cert);
  const cutIdx = certVal.lastIndexOf("(");

  return certVal.substring(0, cutIdx);
};

export default ({ permission }) => {
  const [isFinancesCertShow, setIsFinancesCertShow] = useState(false);
  const [accountInfo, setAccountInfo] = useState({});
  const [state, setState] = useState({});

  const submit = (data) => {
    viewLoading(true);
    if (isEmpty(accountInfo)) {
      // 첫 등록
      const formData = {
        orgCd: "hometax",
        loginMethod: "CERT",
        signCert: data.DER2PEM,
        signPri: data.KEY2PEM,
        signPw: data.password,
        signName: data.certName,
        signProvider: data.pub,
        signExpired: data.toDt,
      };
      postFinancesAuth(formData)
        .then(() => {
          getAccount();
        })
        // .catch((err) => {
        //   console.log(err.response.message);
        // })
        .finally(() => viewLoading(false));
    } else {
      // 인증서 변경
      const formData = {
        loginMethod: "CERT",
        signCert: data.DER2PEM,
        signPri: data.KEY2PEM,
        signPw: data.password,
        signName: data.certName,
        signProvider: data.pub,
        signExpired: data.toDt,
      };
      modifyFinancesAccounts(accountInfo.idx, formData).then(() => {
        getAccount();
      }).catch(() => { })
        .finally(() => viewLoading(false));
    }
  };

  useEffect(() => {
    getAccount();
  }, []);
  // certName
  // expireDate
  const getAccount = () => {
    viewLoading(true);
    getFinancesAccounts("hometax")
      .then((res) => {
        res = res.data.accounts.find((account) => account.orgCd === "hometax");
        const state = FINANCE_SCRAPING_STATE.find(state => state.value === res?.financeScrapings[0]?.state);
        setState(state);
        setAccountInfo(res);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => viewLoading(false));
  };

  return (
    <div className="home-tax-wrap">
      <CardHeader className="border-bottom-none">
        <CardTitle>
          <span className="card-header-title">전자세금계산서</span> 및
          현금영수증
        </CardTitle>
        <CardUnit>
          {permission.level > 1 && (
            <DataComponent
              field={{
                type: "button",
                label: isEmpty(accountInfo) ? "인증서 등록" : "인증서 변경",
                size: "small",
                color: "line",
                action: () => {
                  getFinancesType("hometax").then((res) => {
                    setIsFinancesCertShow(true);
                  });
                },
              }}
            />
          )}
        </CardUnit>
      </CardHeader>
      <CardBody className="p-0 margin-top-14">
        <div className="cert-on-box">
          {!isEmpty(accountInfo) ? (
            <>
              <div className="left-site">
                <div className="lock-shield-icon-wrap">
                  <Icon src={LockIcon} className="lock-icon" />
                  <div className="shield-icon-wrap">
                    <Icon src={ShieldIcon} className="shield-icon" />
                  </div>
                </div>
              </div>
              <div className="right-site">
                <p className="company-name">
                  {findCertName(accountInfo.signName) || accountInfo.signName}
                  {!isEmpty(state) && (
                    <Badge
                      className="margin-left-8"
                      color={state.color}
                      size="sm"
                      label={state.label}
                    />
                  )}
                </p>
                <p className="expire-date">
                  만료일<span className="date">{accountInfo.signExpired}</span>
                </p>
              </div>
            </>
          ) : (
            <>
              <div className="empty-cert">등록된 인증서가 없습니다.</div>
            </>
          )}
        </div>
      </CardBody>
      <FinancesCert
        isShow={isFinancesCertShow}
        toggle={setIsFinancesCertShow}
        submit={submit}
      ></FinancesCert>
    </div>
  );
};
